// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-announcements .filter-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.admin-announcements .checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.admin-announcements .announcements-overview {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.admin-announcements .department-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.admin-announcements .department-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.admin-announcements .department-header.clickable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.admin-announcements .department-header.clickable:hover {
  background: #e9ecef;
}

.admin-announcements .department-header h3 {
  margin: 0;
  flex: 1 1;
  font-size: 1.1rem;
}

.admin-announcements .expand-icon {
  font-size: 0.8rem;
  color: #6c757d;
}

.admin-announcements .announcement-count {
  font-size: 0.875rem;
  color: #6c757d;
  background: #e9ecef;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.admin-announcements .department-announcements {
  padding: 1rem 1.5rem;
}

.admin-announcements .announcement-card {
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 4px solid;
  background: #f8f9fa;
  border-radius: 0 8px 8px 0;
}

.admin-announcements .announcement-card:last-child {
  margin-bottom: 0;
}

.admin-announcements .announcement-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.admin-announcements .priority-icon {
  font-size: 1.1rem;
}

.admin-announcements .announcement-title {
  font-weight: 600;
  flex: 1 1;
}

.admin-announcements .pinned-badge {
  font-size: 0.75rem;
  background: #ffc107;
  color: #000;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
}

.admin-announcements .priority-badge {
  font-size: 0.65rem;
  color: white;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-weight: 600;
}

.admin-announcements .announcement-content {
  margin: 0.5rem 0;
  color: #495057;
  line-height: 1.5;
}

.admin-announcements .announcement-footer {
  display: flex;
  gap: 1rem;
  font-size: 0.8rem;
  color: #6c757d;
  flex-wrap: wrap;
}

.admin-announcements .announcement-expires {
  color: #dc3545;
}

.admin-announcements .no-content {
  color: #6c757d;
  font-style: italic;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/AdminAnnouncements.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".admin-announcements .filter-controls {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.admin-announcements .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.admin-announcements .announcements-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.admin-announcements .department-section {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.admin-announcements .department-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.admin-announcements .department-header.clickable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.admin-announcements .department-header.clickable:hover {\n  background: #e9ecef;\n}\n\n.admin-announcements .department-header h3 {\n  margin: 0;\n  flex: 1;\n  font-size: 1.1rem;\n}\n\n.admin-announcements .expand-icon {\n  font-size: 0.8rem;\n  color: #6c757d;\n}\n\n.admin-announcements .announcement-count {\n  font-size: 0.875rem;\n  color: #6c757d;\n  background: #e9ecef;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n}\n\n.admin-announcements .department-announcements {\n  padding: 1rem 1.5rem;\n}\n\n.admin-announcements .announcement-card {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-left: 4px solid;\n  background: #f8f9fa;\n  border-radius: 0 8px 8px 0;\n}\n\n.admin-announcements .announcement-card:last-child {\n  margin-bottom: 0;\n}\n\n.admin-announcements .announcement-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.admin-announcements .priority-icon {\n  font-size: 1.1rem;\n}\n\n.admin-announcements .announcement-title {\n  font-weight: 600;\n  flex: 1;\n}\n\n.admin-announcements .pinned-badge {\n  font-size: 0.75rem;\n  background: #ffc107;\n  color: #000;\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n}\n\n.admin-announcements .priority-badge {\n  font-size: 0.65rem;\n  color: white;\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.admin-announcements .announcement-content {\n  margin: 0.5rem 0;\n  color: #495057;\n  line-height: 1.5;\n}\n\n.admin-announcements .announcement-footer {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.8rem;\n  color: #6c757d;\n  flex-wrap: wrap;\n}\n\n.admin-announcements .announcement-expires {\n  color: #dc3545;\n}\n\n.admin-announcements .no-content {\n  color: #6c757d;\n  font-style: italic;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
